import Vue from 'vue'
import Router from 'vue-router'

const Login = () => import(/* webpackChunkName: "login" */ './views/Login.vue')
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ './views/Dashboard.vue')
const Users = () => import(/* webpackChunkName: "admin-users" */ './views/Users.vue')
const Demands = () => import(/* webpackChunkName: "admin-review" */ './views/Demands.vue')
const Videos = () => import(/* webpackChunkName: "admin-review" */ './views/Videos.vue')
const Orders = () => import(/* webpackChunkName: "admin-business" */ './views/Orders.vue')
const Finance = () => import(/* webpackChunkName: "admin-business" */ './views/Finance.vue')
const Agreements = () => import(/* webpackChunkName: "admin-settings" */ './views/Agreements.vue')
const Config = () => import(/* webpackChunkName: "admin-settings" */ './views/Config.vue')
const SafetyOps = () => import(/* webpackChunkName: "admin-safety" */ './views/SafetyOps.vue')

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/login', component: Login },
    { path: '/', redirect: '/overview' },
    { path: '/overview', component: Dashboard },
    { path: '/users', component: Users },
    { path: '/demands', component: Demands },
    { path: '/videos', component: Videos },
    { path: '/orders', component: Orders },
    { path: '/finance', component: Finance },
    { path: '/agreements', component: Agreements },
    { path: '/safety', component: SafetyOps },
    { path: '/config', component: Config }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && !localStorage.getItem('adminToken')) {
    next('/login')
    return
  }
  next()
})

export default router
